var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrown2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.0436 16.168L5.00687 9.83687C4.92904 9.36145 5.52972 9.03882 5.95928 9.32515L9.50653 11.6879C9.78093 11.8708 10.1701 11.8116 10.3617 11.5575L13.4968 7.40463C13.7373 7.08648 14.2606 7.08962 14.4956 7.4109L17.5839 11.6243C17.777 11.8878 18.1796 11.9469 18.456 11.7525L22.0282 9.24046C22.4577 8.93845 23.0774 9.26556 22.992 9.74994L21.859 16.168H6.0436Z",
    fill: "#9CA3AF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 18.168H22V20.2527C22 20.7582 21.6323 21.168 21.1787 21.168H6.82133C6.36775 21.168 6 20.7582 6 20.2527V18.168Z",
    fill: "#9CA3AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown2);
export default __webpack_public_path__ + "static/media/crown_2.1368975f324913d833222d7bf26e1117.svg";
export { ForwardRef as ReactComponent };